// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/automations/v1/automations_executions.proto" (package "c1.api.automations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AutomationExecutionActionsService } from "./automations_executions";
import type { TerminateAutomationResponse } from "./automations_executions";
import type { TerminateAutomationRequest } from "./automations_executions";
import { AutomationExecutionService } from "./automations_executions";
import type { GetAutomationExecutionStepOutputResponse } from "./automations_executions";
import type { GetAutomationExecutionStepOutputRequest } from "./automations_executions";
import type { ListAutomationExecutionStepsResponse } from "./automations_executions";
import type { ListAutomationExecutionStepsRequest } from "./automations_executions";
import type { ListAutomationExecutionsResponse } from "./automations_executions";
import type { ListAutomationExecutionsRequest } from "./automations_executions";
import type { GetAutomationExecutionResponse } from "./automations_executions";
import type { GetAutomationExecutionRequest } from "./automations_executions";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AutomationExecutionSearchService } from "./automations_executions";
import type { SearchAutomationExecutionStepsResponse } from "./automations_executions";
import type { SearchAutomationExecutionStepsRequest } from "./automations_executions";
import type { SearchAutomationExecutionCountForAppResponse } from "./automations_executions";
import type { SearchAutomationExecutionCountForAppRequest } from "./automations_executions";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SearchAutomationExecutionsResponse } from "./automations_executions";
import type { SearchAutomationExecutionsRequest } from "./automations_executions";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationExecutionSearchService
 */
export interface IAutomationExecutionSearchServiceClient {
    /**
     * @generated from protobuf rpc: SearchAutomationExecutions
     */
    searchAutomationExecutions(input: SearchAutomationExecutionsRequest, options?: RpcOptions): UnaryCall<SearchAutomationExecutionsRequest, SearchAutomationExecutionsResponse>;
    /**
     * @generated from protobuf rpc: SearchAutomationExecutionCountForApp
     */
    searchAutomationExecutionCountForApp(input: SearchAutomationExecutionCountForAppRequest, options?: RpcOptions): UnaryCall<SearchAutomationExecutionCountForAppRequest, SearchAutomationExecutionCountForAppResponse>;
    /**
     * @generated from protobuf rpc: SearchAutomationExecutionSteps
     */
    searchAutomationExecutionSteps(input: SearchAutomationExecutionStepsRequest, options?: RpcOptions): UnaryCall<SearchAutomationExecutionStepsRequest, SearchAutomationExecutionStepsResponse>;
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationExecutionSearchService
 */
export class AutomationExecutionSearchServiceClient implements IAutomationExecutionSearchServiceClient, ServiceInfo {
    typeName = AutomationExecutionSearchService.typeName;
    methods = AutomationExecutionSearchService.methods;
    options = AutomationExecutionSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SearchAutomationExecutions
     */
    searchAutomationExecutions(input: SearchAutomationExecutionsRequest, options?: RpcOptions): UnaryCall<SearchAutomationExecutionsRequest, SearchAutomationExecutionsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAutomationExecutionsRequest, SearchAutomationExecutionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAutomationExecutionCountForApp
     */
    searchAutomationExecutionCountForApp(input: SearchAutomationExecutionCountForAppRequest, options?: RpcOptions): UnaryCall<SearchAutomationExecutionCountForAppRequest, SearchAutomationExecutionCountForAppResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAutomationExecutionCountForAppRequest, SearchAutomationExecutionCountForAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAutomationExecutionSteps
     */
    searchAutomationExecutionSteps(input: SearchAutomationExecutionStepsRequest, options?: RpcOptions): UnaryCall<SearchAutomationExecutionStepsRequest, SearchAutomationExecutionStepsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAutomationExecutionStepsRequest, SearchAutomationExecutionStepsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationExecutionService
 */
export interface IAutomationExecutionServiceClient {
    /**
     * @generated from protobuf rpc: GetAutomationExecution
     */
    getAutomationExecution(input: GetAutomationExecutionRequest, options?: RpcOptions): UnaryCall<GetAutomationExecutionRequest, GetAutomationExecutionResponse>;
    /**
     * @generated from protobuf rpc: ListAutomationExecutions
     */
    listAutomationExecutions(input: ListAutomationExecutionsRequest, options?: RpcOptions): UnaryCall<ListAutomationExecutionsRequest, ListAutomationExecutionsResponse>;
    /**
     * @generated from protobuf rpc: ListAutomationExecutionSteps
     */
    listAutomationExecutionSteps(input: ListAutomationExecutionStepsRequest, options?: RpcOptions): UnaryCall<ListAutomationExecutionStepsRequest, ListAutomationExecutionStepsResponse>;
    /**
     * @generated from protobuf rpc: GetAutomationExecutionStepOutput
     */
    getAutomationExecutionStepOutput(input: GetAutomationExecutionStepOutputRequest, options?: RpcOptions): UnaryCall<GetAutomationExecutionStepOutputRequest, GetAutomationExecutionStepOutputResponse>;
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationExecutionService
 */
export class AutomationExecutionServiceClient implements IAutomationExecutionServiceClient, ServiceInfo {
    typeName = AutomationExecutionService.typeName;
    methods = AutomationExecutionService.methods;
    options = AutomationExecutionService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAutomationExecution
     */
    getAutomationExecution(input: GetAutomationExecutionRequest, options?: RpcOptions): UnaryCall<GetAutomationExecutionRequest, GetAutomationExecutionResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAutomationExecutionRequest, GetAutomationExecutionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAutomationExecutions
     */
    listAutomationExecutions(input: ListAutomationExecutionsRequest, options?: RpcOptions): UnaryCall<ListAutomationExecutionsRequest, ListAutomationExecutionsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAutomationExecutionsRequest, ListAutomationExecutionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAutomationExecutionSteps
     */
    listAutomationExecutionSteps(input: ListAutomationExecutionStepsRequest, options?: RpcOptions): UnaryCall<ListAutomationExecutionStepsRequest, ListAutomationExecutionStepsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAutomationExecutionStepsRequest, ListAutomationExecutionStepsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAutomationExecutionStepOutput
     */
    getAutomationExecutionStepOutput(input: GetAutomationExecutionStepOutputRequest, options?: RpcOptions): UnaryCall<GetAutomationExecutionStepOutputRequest, GetAutomationExecutionStepOutputResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAutomationExecutionStepOutputRequest, GetAutomationExecutionStepOutputResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationExecutionActionsService
 */
export interface IAutomationExecutionActionsServiceClient {
    /**
     * @generated from protobuf rpc: TerminateAutomation
     */
    terminateAutomation(input: TerminateAutomationRequest, options?: RpcOptions): UnaryCall<TerminateAutomationRequest, TerminateAutomationResponse>;
}
/**
 * @generated from protobuf service c1.api.automations.v1.AutomationExecutionActionsService
 */
export class AutomationExecutionActionsServiceClient implements IAutomationExecutionActionsServiceClient, ServiceInfo {
    typeName = AutomationExecutionActionsService.typeName;
    methods = AutomationExecutionActionsService.methods;
    options = AutomationExecutionActionsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: TerminateAutomation
     */
    terminateAutomation(input: TerminateAutomationRequest, options?: RpcOptions): UnaryCall<TerminateAutomationRequest, TerminateAutomationResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TerminateAutomationRequest, TerminateAutomationResponse>("unary", this._transport, method, opt, input);
    }
}
